<template>
  <div v-show="opened" ref="el" class="form-field-dropbox-wrapper">
    <ul class="form-field-dropbox">
      <FormFieldSelectListOption
        v-for="(option, i) in options"
        ref="itemRefs"
        :key="option.value"
        :class="'element-' + i"
        :index="i"
        :value="option.value"
        :name="option.name"
        :focused="model === i"
        @over="handleOtionFocus"
        @select="handleSelect"
      />
    </ul>
  </div>
</template>
<script setup lang="ts">
interface Props {
  opened: boolean;
  options: FormFieldOption[];
}
defineProps({
  opened: { type: Boolean },
  options: null
});
const index = ref<number>(0);
const model = defineModel<number>();
const el = ref(null);
const bounding = useElementBounding(el);
const itemRefs = ref([]);
const emit = defineEmits(["update", "select"]);
const handleOtionFocus = (i) => {
  index.value = i;
  emit('update', index.value);
};
const handleSelect = (i) => {
  index.value = i;
  emit('select', index.value);
};
watch(
  () => model.value,
  (to) => {
    if (to !== index.value) {
      index.value = to;
      scrollContainerToIndex(to);
    }
  }
);

const scrollContainerToIndex = (value) => {
  const itemEl = el.value.querySelector(`.element-${value}`);
  const elementRect = itemEl.getBoundingClientRect();
  if (elementRect.top < bounding.top.value) {
    el.value.scrollBy(0, elementRect.top - bounding.top.value);
  } else if (elementRect.bottom > bounding.bottom.value) {
    el.value.scrollBy(0, elementRect.bottom - bounding.bottom.value);
  }
};
</script>
<style lang="scss" scoped>
.form-field-dropbox-wrapper {
  overflow: hidden;
  border-radius: 1.8rem;
  &::-webkit-scrollbar {
    width: 1rem;
  }
  &::-webkit-scrollbar-thumb,
  &::-webkit-scrollbar-track {
    border-radius: 1.8rem;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--color_primary);
  }

  &::-webkit-scrollbar-track {
    background: var(--color_neutral_0);
  }
}
</style>
